import {
  ALL_COUNTRIES,
  BROKER_HEIGHTENED_RESTRICTION_COUNTRIES_OPTIONS,
  CITIZENSHIP_COUNTRY_OPTIONS,
  RESTRICTED_COUNTRIES_OPTIONS,
  UK_COUNTRY_CODE,
  USA_COUNTRY_CODE,
  pushElementToFront,
  sortCountriesByLabel,
} from "@tastyworks/tastyworks-api"

export function isForeigner(country: string | undefined) {
  return country !== USA_COUNTRY_CODE
}

// matching logic from twapi-ember
export const NON_US_CITIZENSHIP_COUNTRIES = sortCountriesByLabel(
  CITIZENSHIP_COUNTRY_OPTIONS.filter(
    (country) =>
      country !== USA_COUNTRY_CODE &&
      !BROKER_HEIGHTENED_RESTRICTION_COUNTRIES_OPTIONS.includes(country)
  )
)
// currently unused - possible use for entity owners?
// see: account-opening/app/components/trader/citizenship-country-body
export const FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES =
  CITIZENSHIP_COUNTRY_OPTIONS.filter(
    (country) => !RESTRICTED_COUNTRIES_OPTIONS.has(country)
  )

export const ALL_COUNTRIES_WITH_USA_FIRST = pushElementToFront(
  sortCountriesByLabel(ALL_COUNTRIES),
  USA_COUNTRY_CODE
)

if (import.meta.vitest) {
  const { it, expect, describe } = import.meta.vitest

  describe("isForeigner", () => {
    it("returns true when the country is not USA", () => {
      expect(isForeigner(UK_COUNTRY_CODE)).toBe(true)
    })

    it("returns false when the country is USA", () => {
      expect(isForeigner(USA_COUNTRY_CODE)).toBe(false)
    })
  })

  describe("NON_US_CITIZENSHIP_COUNTRIES", () => {
    it("removes the USA and broker heightened restricted countries from the list", () => {
      expect(NON_US_CITIZENSHIP_COUNTRIES.length).toBe(246)
      expect(NON_US_CITIZENSHIP_COUNTRIES.includes(USA_COUNTRY_CODE)).toBe(
        false
      )
      expect(NON_US_CITIZENSHIP_COUNTRIES.includes("RUS")).toBe(false)
    })
  })

  describe("FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES", () => {
    it("removes all restricted countries from the list", () => {
      expect(FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes("RUS")).toBe(false)
      expect(FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes("AGO")).toBe(false)
      expect(FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes("TJK")).toBe(false)
      expect(
        FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes(USA_COUNTRY_CODE)
      ).toBe(true)
    })
  })

  describe("ALL_COUNTRIES_WITH_USA_FIRST", () => {
    it("orders the countries and puts the USA at the start of the list", () => {
      expect(ALL_COUNTRIES_WITH_USA_FIRST.length).toBe(248)
      expect(ALL_COUNTRIES_WITH_USA_FIRST[0]).toBe(USA_COUNTRY_CODE)
    })
  })
}
